import React from 'react'

import Icon from './Icon'

export default ({ options: { acf: { desktop_text, img_pwa_desktop, redirection_link }}}) => (
  <div className="desktop-overlay">
    <div className="desktop-overlay__inner">
      <div className="container">
        <div className="desktop-overlay__logo">
          <Icon className="icon icon-logo" icon="logo" />
        </div>
        <p className="desktop-overlay__text">{desktop_text}</p>
        <div className="desktop-overlay__cta">
          <img src={img_pwa_desktop.url} alt={img_pwa_desktop.alt} />
          <a href={redirection_link.url} className="button button--round">{redirection_link.title}</a>
        </div>
      </div>
    </div>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/Global/DesktopOverlay.js